function removeNonKeyChars(name) {
  const key = name.replace(/[?!#@%^*.,/~$'"` ]/g, '');
  return key;
}

export default removeNonKeyChars;
